import React from 'react';

import Grid from '@mui/material/Grid';
import { Box, Paper} from '@mui/material';

import { Details } from './components';

import {ptDocContainerSx,ptDocGridSx,ptDocPaperSx} from './PTDocStyles';

const PTDoc = () => {
  return (
    <Box sx={ptDocContainerSx}>
      <Paper
        elevation={0}
        sx={ptDocPaperSx}>
        <Grid
          size={{ xs: 12, md: 12 }}
          sx={ptDocGridSx}>
          <Details />
        </Grid>
      </Paper>
    </Box>
  );
};

export default PTDoc;